module.exports = __webpack_public_path__ + "img/location-marker.73d03e10.svg";